module.exports = __webpack_public_path__ + "img/90ne.d627ddf4.svg";